// src/App.js

import { Suspense, lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AgendaButton from "./Components/AgendaButton";
import Footer from "./Components/Footer.js";
import Navbar from "./Components/Navbar.js";
import ScrollToTop from "./Components/ScrollToTop.js";

const Home = lazy(() => import("./Components/Home.js"));
const Expo = lazy(() => import("./Components/Expo.js"));
const Speakers = lazy(() => import("./Components/Speakers.js"));
const Awards = lazy(() => import("./Components/Awards.js"));
const Partners = lazy(() => import("./Components/Partners.js"));
const Sessions = lazy(() => import("./Components/Sessions.js"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />
      <AgendaButton />

      <main>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Navigate to="/2027/overview" />} />
            <Route path="/2027/overview" element={<Home />} />
            <Route path="/2027/exhibition" element={<Expo />} />
            <Route path="/2027/speakers" element={<Speakers />} />
            <Route path="/2027/awards" element={<Awards />} />
            <Route path="/2027/partners" element={<Partners />} />
            <Route path="/2027/sessions" element={<Sessions />} />
          </Routes>
        </Suspense>
      </main>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
